import { render } from "./knowledgeVideoList.vue?vue&type=template&id=d2b08c32&scoped=true"
import script from "./knowledgeVideoList.vue?vue&type=script&lang=js"
export * from "./knowledgeVideoList.vue?vue&type=script&lang=js"

import "./knowledgeVideoList.vue?vue&type=style&index=0&id=d2b08c32&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b08c32"]])

export default __exports__